import { render, staticRenderFns } from "./reserveNew.vue?vue&type=template&id=19708a4c&scoped=true&"
import script from "./reserveNew.vue?vue&type=script&lang=js&"
export * from "./reserveNew.vue?vue&type=script&lang=js&"
import style0 from "./reserveNew.vue?vue&type=style&index=0&id=19708a4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19708a4c",
  null
  
)

export default component.exports